import type { AxiosRequestConfig } from 'axios';
import type {
  UserToken,
  CreateUserToken,
  CreatedUserToken,
} from '@/entities/user/user';
import { authInstance } from '@/shared/api/api-instances/auth/api-instance';

export class TokensAPI {
  static getUserTokens(userId: string, options?: AxiosRequestConfig) {
    return authInstance.get<UserToken[]>(`/api_tokens/${userId}`, {
      ...options,
    });
  }

  static deactivateToken(token_id: string, options?: AxiosRequestConfig) {
    return authInstance.post(`/api_tokens/${token_id}/deactivate`, {
      ...options,
    });
  }

  static createUserToken(body: CreateUserToken, options?: AxiosRequestConfig) {
    return authInstance.post<CreatedUserToken>(`/api_tokens`, body, {
      ...options,
    });
  }
}